import React, { Component } from "react";
import { MultiDropdownList } from "@appbaseio/reactivesearch";
import MultiDropdownListWithFocus from "../../components/MultiDropdownListWithFocus";

class WRShape extends Component {
  render() {
    return (
      <div className="wr-shape">
        <MultiDropdownList
          title={
            this.props.appType === "original"
              ? "WR - Shape"
              : "Center Shape (WR)"
          }
          className="form-field"
          componentId="WRShape"
          dataField={this.props.data}
          renderListItem={(label) => (
            <div>{label !== "NULL" ? label : "None"}</div>
          )}
          size={100}
          showCount={false}
          showSearch={true}
          sortBy="asc"
          placeholder={this.props.appType === "original" ? "Select values" : ""}
        />
      </div>
    );
  }
}

export default MultiDropdownListWithFocus(WRShape);
